import { sxStyle } from './styles';
import { TextPartsLayout } from './TextPartsLayout';

export const NonRefundableInfo = ({
  index,
  containerStyle,
  layout = 'stacked',
}) => {
  const parts = [
    {
      key: 'title',
      text: 'No Reembolsable',
      sx: sxStyle.seeNoRefundability,
      id: `non-refundableTitle-${index}`,
    },
    {
      key: 'text',
      text: 'No puedes cancelar ni realizar cambios.',
      sx: { ...sxStyle.seeSubNoRefundability, textAlign: 'left' },
      id: `non-refundableText-${index}`,
    },
  ];

  return (
    <TextPartsLayout
      parts={parts}
      layout={layout}
      containerStyle={containerStyle}
    />
  );
};
